const uppercasePassportNumber = number => {
  return number.toUpperCase();
};

export default uppercasePassportNumber;
